import { makeStyles } from "@material-ui/core/styles";
import { Height } from "@material-ui/icons";
import { displayValue } from "utils/randomKey";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const DATE_RANGE = "boilerplate/GSTR2A2BNEWRECO/DATE_RANGE";

export function setDateRange(dateRange) {
  return {
    type: DATE_RANGE,
    payload: dateRange,
  };
}
//fix

export function getLastDateOfMonth(date) {
  let inputDate = new Date(date);

  let lastDate = new Date(inputDate.getFullYear(), inputDate.getMonth() + 1, 0);

  return lastDate;
}
export function getStartDate(yearRange) {
  const match = yearRange.match(/^(\d{4})-(\d{2})$/);
  if (!match) {
    return;
  }

  const startYear = match[1];
  const startDate = new Date(`${startYear}-04-01T00:00:00Z`);

  if (isNaN(startDate.getTime())) {
    throw new Error("Invalid start date. Check the input format.");
  }

  // Return the startDate as a localized string
  return startDate.toString();
}

export function getEndDate(yearRange) {
  // Match format YYYY-YY
  const match = yearRange.match(/^(\d{4})-(\d{2})$/);
  if (!match) {
    return;
    // throw new Error("Invalid input format. Expected format: YYYY-YY");
  }

  // Extract the first year as an integer
  const startYear = parseInt(match[1], 10);
  const endYear = startYear + 1; // Calculate the second year (YYYY + 1)

  // Construct the end date
  const endDate = new Date(`${endYear}-03-31T00:01:00Z`);

  // Validate the endDate object
  if (isNaN(endDate.getTime())) {
    throw new Error("Invalid end date. Check the input format.");
  }

  // Return the endDate as a localized string
  return endDate.toString(); // Returns a localized date string
}

export function getFinancialYearStartDate(initialStartDate) {
  if (!initialStartDate) {
    return null;
  }

  const date = new Date(initialStartDate);
  if (isNaN(date.getTime())) {
    return null;
  }

  const month = date.getMonth(); // 0-based
  const year = month < 3 ? date.getFullYear() - 1 : date.getFullYear();

  // Return April 1 of the financial year
  return new Date(year, 3, 1, 0, 0, 0, 0);
}

export function getFinancialYearEndDate(initialEndDate) {
  if (!initialEndDate) {
    return null;
  }

  const date = new Date(initialEndDate);
  if (isNaN(date.getTime())) {
    return null;
  }

  const month = date.getMonth();
  const year = month < 3 ? date.getFullYear() : date.getFullYear() + 1;

  return new Date(year, 2, 31, 0, 0, 0, 0);
}

export function CommonStyle() {
  return {
    fontFamily: "Gt-Walsheim-medium",
    fontSize: "11px",
    fontWeight: "bold",
    textAlign: "center",
    textWrap: "wrap",
    wordBreak: "break-word",
    backgroundColor: "white",
    verticalAlign: "middle",
  };
}

export function CommonHeaderStyle() {
  return {
    fontFamily: "Gt-Walsheim-medium",
    fontSize: "12px",
    fontWeight: "bold",
    verticalAlign: "middle",
    textWrap: "wrap",
    wordBreak: "break-word",
    textAlign: "center",
  };
}
const useStyles = makeStyles((theme) => ({
  formControl: {
    width: 220,
    marginTop: "10px",
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "red",
    },
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

export { useStyles, MenuProps };

// Helper function to convert date from YYYY-MM-DD to DD/MM/YYYY
export const convertDateFormat = (dateString) => {
  if (!dateString) return dateString;

  // Check if date is in YYYY-MM-DD format
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (dateRegex.test(dateString)) {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  }

  // Return as is if already in different format
  return dateString;
};

export const displayNullFormatter = (row, property) => {
  return (
    <>
      {row[property] === null ||
      row[property] === undefined ||
      row[property] === ""
        ? "--"
        : row[property]}
    </>
  );
};

export const displayCommaFormatter = (row, property) => {
  return (
    <>
      {row[property] === null ||
      row[property] === undefined ||
      row[property] === ""
        ? "--"
        : displayValue(Number(row[property]))}
    </>
  );
};

// Convert 12-hour format to 24-hour format
export const convertTo24Hour = (time12h) => {
  if (!time12h) return "";

  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }

  return `${String(hours).padStart(2, "0")}:${minutes}`;
};

// Convert date to YYYY-MM-DD format
export const formatDateToString = (date) => {
  if (!date) return "";
  // If it's already a string in YYYY-MM-DD format, return as is
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  // If it's a Date object or ISO string, convert to YYYY-MM-DD using local time
  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) {
    console.error("Invalid date:", date);
    return "";
  }
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Format date to DD/MM/YYYY
export const formatDateToDDMMYYYY = (date) => {
  if (!date) return "";

  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) {
    console.error("Invalid date:", date);
    return "";
  }

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  return `${day}/${month}/${year}`;
};

export const headerColumns = [
  {
    value: "History",
    id: 1,
  },
  {
    value: "Detailed",
    id: 2,
  },
];
